import { Observable, Subject } from "rxjs";
import { SimpleValidation } from "./simple-validation.model";

declare var Operate: any;

export class CustomValidation {

    validations?: Array<SimpleValidation>;
    /**
     * ej: (a <b&& b > t) && (a != t) && !u
     */
    pattern?: string;
    validationSubject = new Subject<boolean>();


    constructor(source: Partial<CustomValidation>) {
        
        Object.assign(this, source);

        this.validations?.forEach(item => {
            item.getObservable().subscribe(value => {
                this.validatePattern();
            });
        });
    }

    getObservable(): Observable<boolean> {
        return this.validationSubject.asObservable();
    }

    validatePattern() {
        let response = false;
        type Data = { [key: string]: any };
        let operators: Data = {};
        let currentPattern = this.pattern;

        this.validations?.forEach(item => {
            operators[item.patternIndex! as keyof Data] = item.response!;
            currentPattern = currentPattern?.replace(item.patternIndex!, item.response + '');
        });

        response = Operate.parse(operators, this.pattern);
        this.validationSubject.next(response);
    }
}